// Module
var code = "<p><a href=\"introduction/workers\">预算项目</a> 是BitShares系统中独有的概念。他们是一些期望通过提供服务来从区块链获得奖金的工作项目提案。一项提案包含一个指向网站或论坛帖子的链接，在其中详细解释了工作项目的介绍。在这里<a href=\"https://bitsharestalk.org/index.php/board,75.0.html\">BitSharestalk - Stakeholder Proposals Board</a>可以看到一些提案。</p> ";
// Exports
export default code;